<template>
  <div>
    <v-dialog
      v-model="d_cp"
      persistent
      max-width="550px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <div class="d-flex align-center">
            <div class="d-flex align-center">
              <b> {{ title }} </b>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn fab x-small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container style="height: max-content">
            <v-stepper v-model="step" flat>
              <v-stepper-items>
                <v-stepper-content style="margin: 0; padding: 0" step="1">
                  <div class="pa-4">
                    <div v-if="inventory.data">
                      <h4>Download and read the guideline</h4>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <a
                            v-if="
                              inventory.data.category.link_guideline_proposal
                            "
                            :href="
                              inventory.data.category.link_guideline_proposal
                            "
                            class="no_decoration"
                            target="_blank"
                          >
                            <div class="link_temp">
                              <b class="color_default small_txt">
                                TSA Management Guideline</b
                              >
                            </div>
                          </a>
                          <div class="unlink_temp" v-else>
                            <b style="color: #99c1b4" class="small_txt">
                              TSA Management Guideline</b
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="mt-2">
                      <h4>Please follow below instructions:</h4>
                      <v-row no-gutters>
                        <v-col cols="12" md="4" class="pa-2">
                          <h2>1</h2>
                          <div
                            class="d-flex flex-column align-center justify-center"
                          >
                            <div
                              style="height: 18vh; width: 80%; display: flex"
                            >
                              <v-img
                                class="my-2"
                                src="../../../../assets/img/proposal/step1.png"
                                width="100%"
                                contain
                                alt="John"
                              />
                            </div>
                            <p style="text-align: center">
                              Download and read the guideline
                            </p>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4" class="pa-2">
                          <h2>2</h2>
                          <div
                            class="d-flex flex-column align-center justify-center"
                          >
                            <div
                              style="height: 18vh; width: 80%; display: flex"
                            >
                              <v-img
                                class="my-2"
                                src="../../../../assets/img/proposal/step3.png"
                                width="100%"
                                contain
                                alt="John"
                              />
                            </div>
                            <p style="text-align: center">
                              Submit your proposal and fill in necessary data
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-2">
                          <h2>3</h2>
                          <div
                            class="d-flex flex-column align-center justify-center"
                          >
                            <div
                              style="height: 18vh; width: 80%; display: flex"
                            >
                              <v-img
                                class="my-2"
                                src="../../../../assets/img/proposal/step4.png"
                                width="100%"
                                contain
                                alt="John"
                              />
                            </div>

                            <p style="text-align: center">
                              You can monitor your proposal progress in this
                              platform
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div class="d-flex justify-end my-2">
                    <v-btn
                      class="bg_default text-capitalize rounded-lg"
                      depressed
                      dark
                      @click="nextStep"
                      >Next</v-btn
                    >
                  </div>
                </v-stepper-content>
                <v-stepper-content style="margin: 0; padding: 0" step="2">
                  <div class="pa-4" v-if="inventory.data">
                    <div>
                      <h4><b>Title of Proposal</b></h4>
                      <v-text-field
                        class="mt-2 rounded-lg"
                        dense
                        filled
                        readonly
                        outlined
                        v-model="inventory.data.title"
                        placeholder="Put the title here"
                        hide-details
                        color="green"
                      ></v-text-field>
                    </div>
                    <div>
                      <h4><b>Description of Proposal</b></h4>
                      <v-textarea
                        class="mt-2 rounded-lg"
                        auto-grow
                        color="green"
                        outlined
                        rows="4"
                        placeholder="Put the description here"
                        v-model="inventory.data.description"
                        hide-details
                        dense
                      ></v-textarea>
                    </div>
                    <div class="mt-3">
                      <h4 class="mb-2">Execution Date</h4>
                      <v-row>
                        <v-col cols="6">
                          <p class="small_txt font-weight-bold mb-0">Start Date</p>
                          <v-menu
                            v-model="showPickerStart"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            max-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="inventory.data.start_date"
                                prepend-inner-icon="mdi-calendar-range"
                                readonly
                                color="green"
                                dense
                                hide-details
                                v-on="on"
                                placeholder="Start Event Date"
                                outlined
                                class="rounded-lg"
                              ></v-text-field>
                            </template>
                            <div>
                              <v-date-picker
                                v-model="inventory.data.start_date"
                                @input="closeDateMenu('start')"
                              ></v-date-picker>
                            </div>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <p class="small_txt font-weight-bold mb-0">End Date</p>
                          <v-menu
                            v-model="showPickerEnd"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            max-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="inventory.data.end_date"
                                prepend-inner-icon="mdi-calendar-range"
                                readonly
                                color="green"
                                dense
                                hide-details
                                v-on="on"
                                placeholder="Start Event Date"
                                outlined
                                class="rounded-lg"
                              ></v-text-field>
                            </template>
                            <div>
                              <v-date-picker
                                v-model="inventory.data.end_date"
                                @input="closeDateMenu('end')"
                              ></v-date-picker>
                            </div>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="mt-3">
                      <h4>Link For Yout Proposal</h4>
                      <v-text-field
                        class="rounded-lg"
                        dense
                        outlined
                        v-model="inventory.data.proposal.link"
                        placeholder="Put the link here"
                        hide-details
                        color="green"
                      ></v-text-field>
                    </div>

                    <!-- <div
                      class="mt-2"
                      v-for="(item, i) in inventory.form"
                      :key="i"
                    >
                      <h4 v-html="item.question"></h4>
                      <p
                        class="default_txt"
                        v-if="item.attr == 'text' && item.additional"
                        v-html="item.additional"
                      ></p>
                      <v-textarea
                        v-if="item.attr == 'text'"
                        class="my-2 rounded-lg"
                        auto-grow
                        outlined
                        rows="3"
                        placeholder="Type here"
                        v-model="item[`answer`]"
                        color="green"
                        hide-details
                        dense
                      ></v-textarea>
                      <v-menu
                        v-if="item.attr == 'date'"
                        v-model="item.menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        max-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            style="width: 40%"
                            v-model="item[`answer`]"
                            prepend-inner-icon="mdi-calendar-range"
                            readonly
                            color="green"
                            dense
                            hide-details
                            v-on="on"
                            placeholder="Click here"
                            outlined
                            class="rounded-lg"
                          ></v-text-field>
                        </template>
                        <div>
                          <v-date-picker
                            v-model="item[`answer`]"
                            @input="item.menu = false"
                          ></v-date-picker>
                        </div>
                      </v-menu>
                      <div
                        class="pa-2"
                        v-if="item.id == 13 && item.attr == 'checkbox'"
                      >
                        <b>Values</b>
                        <v-row no-gutters>
                          <v-col
                            cols="4"
                            v-for="(val, j) in item.opt.values"
                            :key="`val${j}`"
                          >
                            <v-checkbox
                              color="green"
                              hide-details
                              class="mt-2"
                              v-model="item[`answer`].values"
                              :label="val"
                              :value="val"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <div class="mt-2">
                          <b>Competencies</b>
                        </div>
                        <v-row no-gutters>
                          <v-col
                            cols="4"
                            v-for="(val, j) in item.opt.competencies"
                            :key="`com${j}`"
                          >
                            <v-checkbox
                              color="green"
                              hide-details
                              class="mt-2"
                              v-model="item[`answer`].competencies"
                              :label="val"
                              :value="val"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-if="item.id == 14 && item.attr == 'checkbox'">
                        <v-row no-gutters>
                          <v-col
                            cols="4"
                            v-for="(val, j) in item.opt"
                            :key="`14${j}`"
                          >
                            <v-checkbox
                              color="green"
                              hide-details
                              class="mt-2"
                              v-model="item[`answer`]"
                              :label="val"
                              :value="val"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </div> -->
                  </div>
                  <div class="d-flex justify-space-between my-2">
                    <v-btn class="btn" text @click="prevStep">
                      <h4 style="color: #006341; text-decoration: underline">
                        Back
                      </h4>
                    </v-btn>
                    <v-btn
                      class="bg_default text-capitalize rounded-lg"
                      depressed
                      dark
                      @click="createData"
                      >Save</v-btn
                    >
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
            <v-overlay
              :absolute="true"
              color="white"
              opacity="1"
              :value="loading"
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                color="#006341"
              ></v-progress-circular>
              <b class="color_default">Loading...</b>
            </v-overlay>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "createProposalScholar",
  props: ["d_cp", "title", "inventory", "type"],
  computed: {
    ...mapState({
      profile: (state) => state.profile,
    }),
  },
  data() {
    return {
      loading: false,
      step: 1,
      dataSetProposal: null,
      showPickerEnd: false,
      showPickerStart: false,
      form: {
        content: "",
        type_content: "embed",
        notes: "",
      },
    };
  },
  mounted() {
    console.log(this.inventory);
  },
  methods: {
    nextStep() {
      this.step = 2;
    },
    prevStep() {
      this.step = 1;
    },
    mutate() {
      let answer = {};
      this.inventory.form.forEach((el) => {
        answer[el.id] = el[`answer`];
      });
    },
    closeDateMenu(state) {
      if (state == "start") {
        this.showPickerStart = false;
        this.inventory.data.start_date == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      } else {
        this.showPickerEnd = false;
        this.inventory.data.end_date == "" ? this.date.format("dddd, MMMM Do YYYY") : "";
      }
    },
    createData() {
      this.loading = true;
      let answer = {};
      // this.inventory.form.forEach((el) => {
      //   answer[el.id] = el[`answer`];
      // });
      // this.inventory.body["answer"] = JSON.stringify(answer);
      let  body = {
        tsa_activity_id:this.inventory.body.tsa_activity_id,
        title: this.inventory.data.title,
        description: this.inventory.data.description,
        tsa_category_id:this.inventory.data.tsa_category_id,
        start_date: this.inventory.data.start_date,
        end_date: this.inventory.data.end_date,
        link : this.inventory.data.link,
      };
      let data = {
        path: this.inventory.path,
        body: body,
      };
      console.log(body);
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$emit("refetch");
          this.$emit("close");
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.btn {
  text-transform: unset !important;
}
.link_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00634166;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
.unlink_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d6e6e1;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
</style>
